import React, { createContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import SvgIcon from '@material-ui/core/SvgIcon';
import CheckIcon from '@material-ui/icons/Check';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import TextFormatRoundedIcon from '@material-ui/icons/TextFormatRounded';
import { TrackerObjectiveValueTypes } from 'constants/assignments';
import { get, isEmpty, map } from 'lodash';

import { formatDate } from 'utils/date';

import { ReactComponent as HashtagIcon } from './assets/hashtag.svg';

export const getWorkName = (workItem) => {
  if (!workItem) return '';

  if (workItem.is_feedback) return 'Feedback';
  if (workItem.is_revision) return 'Revision';

  return 'Original';
};

export const getObjectiveValueTypeIcon = (valueType) => {
  const mapper = {
    [TrackerObjectiveValueTypes.CHECKBOX]: CheckBoxOutlinedIcon,
    [TrackerObjectiveValueTypes.CHECK_GRADE]: CheckIcon,
    [TrackerObjectiveValueTypes.RUBRIC_ZERO_FOUR]: FormatListNumberedIcon,
    [TrackerObjectiveValueTypes.RUBRIC_A_TO_F]: FormatListNumberedIcon,
    [TrackerObjectiveValueTypes.NUMBER]: (props) => (
      <SvgIcon component={HashtagIcon} {...props} />
    ),
    [TrackerObjectiveValueTypes.TEXT]: TextFormatRoundedIcon,
    [TrackerObjectiveValueTypes.PERFORMANCE]: TextFormatRoundedIcon,
    [TrackerObjectiveValueTypes.CUSTOM]: (props) => (
      <SvgIcon component={HashtagIcon} {...props} />
    )
  };

  return mapper[valueType];
};

export const getStandardOptionLabel = ({ standard }) => {
  const shortDescription = get(standard, 'short_description', '');

  if (isEmpty(shortDescription)) {
    return get(standard, 'code', '');
  }

  return `${standard.code} - ${shortDescription}`;
};

// Context and provider for storing and accessing the previous location in the app.
export const PreviousLocationContext = createContext();

export const PreviousLocationProvider = ({ children }) => {
  const location = useLocation();
  const previousLocationRef = useRef(null);

  useEffect(() => {
    previousLocationRef.current = location;
  }, [location]);

  return (
    <PreviousLocationContext.Provider value={previousLocationRef.current}>
      {children}
    </PreviousLocationContext.Provider>
  );
};

export const buildSectionsOptions = (sections) =>
  map(sections, (section) => {
    const createdAtFormatted = formatDate({ date: section.created_at });

    return {
      value: section.id,
      label: `${section.section_name} ${createdAtFormatted}`
    };
  });
